import Accordion from "../components/Accordion";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import formulario from "../docs/rendicion/2022/formulario.xlsx";
import informeanual from "../docs/rendicion/2022/informeanual.pdf";
import fase0_1_2022 from "../docs/rendicion/2022/fase0_1.pdf";
import fase0_2_2022 from "../docs/rendicion/2022/fase0_2.pdf";
import fase1_1_2022 from "../docs/rendicion/2022/fase1_1.pdf";
import fase1_2_2022 from "../docs/rendicion/2022/fase1_2.pdf";
import fase1_3_2022 from "../docs/rendicion/2022/fase1_3.pdf";
import fase1_4_2022 from "../docs/rendicion/2022/fase1_4.pdf";
import fase2_1_2022 from "../docs/rendicion/2022/fase2_1.pdf";
import fase2_2_2022 from "../docs/rendicion/2022/fase2_2.pdf";
import fase2_3_2022 from "../docs/rendicion/2022/fase2_3.pdf";
import fase2_5_2022 from "../docs/rendicion/2022/fase2_5.pdf";
import fase3_1_2022 from "../docs/rendicion/2022/fase3_1.pdf";
import fase3_2_2022 from "../docs/rendicion/2022/fase3_2.pdf";

import formulario_2021 from "../docs/rendicion/2021/formulario.xlsx";
import informeanual_2021 from "../docs/rendicion/2021/informe.pdf";
import fase0_1_2021 from "../docs/rendicion/2021/fase0_1.pdf";
import fase0_2_2021 from "../docs/rendicion/2021/fase0_2.pdf";
import fase1_1_2021 from "../docs/rendicion/2021/fase1_1.pdf";
import fase1_2_2021 from "../docs/rendicion/2021/fase1_2.pdf";
import fase1_3_2021 from "../docs/rendicion/2021/fase1_3.pdf";
import fase1_4_2021 from "../docs/rendicion/2021/fase1_4.pdf";
import fase2_1_2021 from "../docs/rendicion/2021/fase2_1.pdf";
import fase2_2_2021 from "../docs/rendicion/2021/fase2_2.pdf";
import fase2_3_2021 from "../docs/rendicion/2021/fase2_3.pdf";
import fase2_5_2021 from "../docs/rendicion/2021/fase2_5.pdf";
import fase3_1_2021 from "../docs/rendicion/2021/fase3_1.pdf";
import fase3_2_2021 from "../docs/rendicion/2021/fase3_2.pdf";
import useContentful from "../hooks/use-contenful";

/* const query = `
query 
{
    videoTemplate(id: "7nkXFo1MUjpp4KrAvMneT0") {
      contentBlock1{json}
      contentBlock2{json}
      contentBlock3{json}
      contentBlock4{json}
      contentBlock5{json}
    }
  
}
`; */
function Rendicion() {
  /*  let { data, errors } = useContentful(query);
  if (errors)
    return <span>{errors.map((error) => error.message).join(",")}</span>;
  if (!data) return <p>Loading...</p>; */
  return (
    <>
      <div className="margin">
        <Breadcumbs
          content={
            <>
              <NavLink to="/rendicioncuentas">Rendición de cuentas</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>

      <div className="lightbluebg">
        <div className="layout8 padding2">
          <h2>Periodo 2025</h2>
          <ul>
            <li>
              <a href="https://eventos.utpl.edu.ec/formulario-sugerencias">
                Formulario de sugerencias / Aporte ciudadano
              </a>
            </li>
          </ul>

          <Accordion title="Fase 0" content={<></>}></Accordion>
          <Accordion title="Fase 1" content={<></>}></Accordion>

          <Accordion title="Fase 2" content={<></>}></Accordion>

          <Accordion title="Fase 3" content={<></>}></Accordion>
        </div>
      </div>

      <div>
        <div className="layout8 padding2">
          <h2>Periodo 2024</h2>
          <ul>
            <li>
              <a href="https://eventos.utpl.edu.ec/formulario-sugerencias">
                Formulario de sugerencias / Aporte ciudadano
              </a>
            </li>
            <li>
              <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/formulario.xlsx">
                Formulario del Consejo de Participación Ciudadana y Control
                Social
              </a>
            </li>

            <li>
              <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/memoria_sostenibilidad.pdf">
                Memoria de Sostenibilidad 2024
              </a>
            </li>
            <li>
              <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/documentos/cumplimiento.pdf">
                Certificado de cumplimiento tributario
              </a>
            </li>
            <li>
              <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/documentos/obligaciones.pdf">
                Certificado de cumplimiento de obligaciones patronales IESS
              </a>
            </li>
          </ul>

          <Accordion
            title="Fase 0"
            content={
              <>
                <p>
                  <b>
                    FASE 0: Organización interna institucional del proceso de
                    rendición de cuentas
                  </b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase0/F0 _1 Delegación de equipo_2024.pdf">
                        Conformación del equipo responsable de la implementación
                        del proceso de rendición de cuentas
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase0/F0_2_PLAN%20DEL%20PROCESO%20DE%20RENDICI%C3%93N%20DE%20CUENTAS.pdf">
                        Diseño de la propuesta y las herramientas necesarias
                        para su desarrollo
                      </a>
                    </p>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 1"
            content={
              <>
                <p>
                  <b>FASE 1: Elaboración del informe de Rendición de Cuentas</b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase1/F1_1_Cumplimiento_POA__2024.pdf">
                        Consolidación de la información cuantitativa y
                        cualitativa de la gestión anual y evaluación de los
                        resultados alcanzados en el período fiscal concluido.
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase1/F1_2_Canales_de_comunicación_y_recolección_de_inf_2024.pdf">
                        Apertura de canales de comunicación virtual y presencial
                        para recabar solicitudes de información en el proceso de
                        rendición de cuentas.
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase1/F1_3_Recepcion_y_analisis_de_informacion.pdf">
                        Recepción y análisis de la información{" "}
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase1/F1_4__Version_preliminar_del_formulario_e_informe_2024.pdf">
                        Carga de la información en el formulario de Rendición de
                        Cuentas y redacción del Informe de Rendición de Cuentas.{" "}
                      </a>
                    </p>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 2"
            content={
              <>
                <p>
                  <b>
                    FASE 2: Deliberación sobre el Informe de RC presentado por
                    la autoridad a la ciudadanía.
                  </b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase2/F2_1 Memoria_de_Sostenibilidad.pdf">
                        Difusión del Informe de Rendición de Cuentas 2024
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase2/F2_2_Convocatoria_al_evento.pdf">
                        Convocatoria pública y abierta a la presentación pública
                        del Informe de Rendición de Cuentas 2024
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase2/F2_3_Informe_de_asistencias_al_evento_de_RC_1signed_signed.pdf">
                        Deliberación pública presencial y con transmisión en
                        vivo del Informe de Rendición de Cuentas 2024
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://www.youtube.com/live/td_BWgE04DM">
                        Difusión del video de deliberación pública de la
                        Rendición de Cuentas, formulario de rendición de cuentas
                        e Informe de Rendición de Cuentas para receptar aportes
                        ciudadanos
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase2/F2_5_Sistematización_de_aportes_ciudadanossigned_signed.pdf">
                        Sistematización de los aportes ciudadanos recibidos y
                        elaboración del Acta de Compromiso
                      </a>
                    </p>
                    <ul>
                      <li>
                        {" "}
                        <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase2/doc5-1.pdf">
                          5.1  Acta de Compromisos UTPL 2024
                        </a>
                        <ul>
                          <li>
                            {" "}
                            <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase2/doc5-2.pdf">
                              5.1.1 Anexo: Actas de constitución de mesas
                              temáticas
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 3"
            content={
              <>
                <p>
                  <b>
                    FASE 3: Entrega del Informe de Rendición de Cuentas al CPCCS
                  </b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase3/doc1.pdf">
                        Entrega del Informe de Rendición de Cuentas al CPCCS
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2025/fase3/doc2.pdf">
                        Entrega del Informe de Rendición de Cuentas a los
                        órganos de control del Estado
                      </a>
                    </p>
                  </li>
                </ol>
              </>
            }
          ></Accordion>
        </div>
      </div>

      <div className="graybg padding">
        <div className="layout8 ">
          <h2>Periodo 2023</h2>
          <ul>
            <li>
              <a href="https://eventos.utpl.edu.ec/formulario-sugerencias">
                Formulario de sugerencias / Aporte ciudadano
              </a>
            </li>
            <li>
              <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/docs/formulario.xlsx">
                Formulario preliminar del Consejo de Participación Ciudadana y
                Control Social
              </a>
            </li>

            <li>
              <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/docs/memoria.pdf">
                Memoria de Sostenibilidad 2023
              </a>
            </li>
          </ul>

          <Accordion
            title="Fase 0"
            content={
              <>
                <p>
                  <b>
                    FASE 0: Organización interna institucional del proceso de
                    rendición de cuentas
                  </b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase0/doc1.pdf">
                        Conformación del equipo responsable de la implementación
                        del proceso de rendición de cuentas
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase0/doc2.pdf">
                        Diseño de la propuesta y las herramientas necesarias
                        para su desarrollo
                      </a>
                    </p>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 1"
            content={
              <>
                <p>
                  <b>FASE 1: Elaboración del informe de Rendición de Cuentas</b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase1/doc1.pdf">
                        Consolidación de la información cuantitativa y
                        cualitativa de la gestión anual y evaluación de los
                        resultados alcanzados en el período fiscal concluido.
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase1/doc2.pdf">
                        Apertura de canales de comunicación virtual y presencial
                        para recabar solicitudes de información en el proceso de
                        rendición de cuentas.
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase1/doc3.pdf">
                        Recepción y análisis de la información{" "}
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase1/doc4.pdf">
                        Carga de la información en el formulario de Rendición de
                        Cuentas y redacción del Informe de Rendición de Cuentas.{" "}
                      </a>
                    </p>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 2"
            content={
              <>
                <p>
                  <b>
                    FASE 2: Deliberación sobre el Informe de RC presentado por
                    la autoridad a la ciudadanía.
                  </b>
                </p>
                <ol>
                  <li>
                    {" "}
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/docs/memoria.pdf">
                        Difusión del Informe de Rendición de Cuentas 2024
                      </a>
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase2/doc2.pdf">
                        Convocatoria pública y abierta a la presentación pública
                        del Informe de Rendición de Cuentas 2024
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase2/doc3.pdf">
                        Deliberación pública presencial y con transmisión en
                        vivo del Informe de Rendición de Cuentas 2023
                      </a>
                    </p>
                  </li>

                  <li>
                    <p>
                      <a href="https://www.facebook.com/share/v/jsu2bMewGkb88GXi/?mibextid=KsPBc6">
                        Difusión del video de deliberación pública de la
                        Rendición de Cuentas, formulario de rendición de cuentas
                        e Informe de Rendición de Cuentas para receptar aportes
                        ciudadanos
                      </a>
                    </p>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 3"
            content={
              <>
                <p>
                  <u>
                    <strong>
                      FASE 3: Entrega del Informe de Rendición de Cuentas al
                      CPCCS
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href="https://utpl.edu.ec/documentos/rendicioncuentas/2023/fase3/doc1.pdf">
                      Entrega del Informe de Rendición de Cuentas al CPCCS.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>
        </div>
      </div>
      {/* 
      <div className="padding  graybg">
        <div className="layout8">
          {documentToReactComponents(data.videoTemplate.contentBlock1.json)}
          <Accordion
            title="Fase 0"
            content={documentToReactComponents(
              data.videoTemplate.contentBlock2.json
            )}
          ></Accordion>
          <Accordion
            title="Fase 1"
            content={documentToReactComponents(
              data.videoTemplate.contentBlock3.json
            )}
          ></Accordion>
          <Accordion
            title="Fase 2"
            content={documentToReactComponents(
              data.videoTemplate.contentBlock4.json
            )}
          ></Accordion>
          <Accordion
            title="Fase 3"
            content={documentToReactComponents(
              data.videoTemplate.contentBlock5.json
            )}
          ></Accordion>
        </div>
      </div> */}
      <div className="layout8 padding">
        <h2>Periodo 2022</h2>
        <div>
          <ul className="padding2">
            <li>
              <a href={informeanual}>Informe anual</a>
            </li>
            <li>
              <a href={formulario}>
                Formulario del Consejo de Participación Ciudadana y Control
                Social
              </a>
            </li>
          </ul>
          <Accordion
            title="Fase 0"
            content={
              <>
                {" "}
                <p>
                  <u>
                    <strong>
                      FASE 0: Organización interna institucional del proceso de
                      rendición de cuentas
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase0_1_2022}>
                      Conformación del equipo responsable de la implementación
                      del proceso de rendición de cuentas.
                    </a>
                  </li>

                  <li>
                    <a href={fase0_2_2022}>
                      Diseño de la propuesta y las herramientas necesarias para
                      su desarrollo.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>
          <Accordion
            title="Fase 1"
            content={
              <>
                <p>
                  <u>
                    <strong>FASE 1: Elaboración del informe de RC</strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase1_1_2022}>
                      Consolidación de la información cuantitativa y cualitativa
                      de la gestión anual y evaluación de los resultados
                      alcanzados en el período fiscal concluido.
                    </a>
                  </li>

                  <li>
                    <a href={fase1_2_2022}>
                      Apertura de canales de comunicación virtual y presencial
                      para recabar solicitudes de información en el proceso de
                      rendición de cuentas.
                    </a>
                  </li>
                  <li>
                    <a href={fase1_3_2022}>
                      Recepción y análisis de la información.
                    </a>
                  </li>
                  <li>
                    <a href={fase1_4_2022}>
                      Carga de la información en el formulario de Rendición de
                      Cuentas y redacción del Informe de Rendición de Cuentas.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 2"
            content={
              <>
                <p>
                  <u>
                    <strong>
                      FASE 2: Deliberación sobre el Informe de RC presentado por
                      la autoridad a la ciudadanía.
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase2_1_2022}>
                      Difusión del Informe de Rendición de Cuentas 2022.
                    </a>
                  </li>

                  <li>
                    <a href={fase2_2_2022}>
                      Convocatoria pública y abierta a la presentación pública
                      del Informe de Rendición de Cuentas 2022.
                    </a>
                  </li>
                  <li>
                    <a href={fase2_3_2022}>
                      Deliberación pública presencial y con transmisión en vivo
                      del Informe de Rendición de Cuentas 2022.
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/utpl.loja/videos/1414945035933464/">
                      Difusión del video de deliberación pública de la Rendición
                      de Cuentas, formulario de rendición de cuentas e Informe
                      de Rendición de Cuentas para receptar aportes ciudadanos.
                      .
                    </a>
                  </li>

                  <li>
                    <a href={fase2_5_2022}>
                      Sistematización de los aportes ciudadanos recibidos y
                      elaboración del Acta de Compromiso. .
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 3"
            content={
              <>
                <p>
                  <u>
                    <strong>
                      FASE 3: Entrega del Informe de Rendición de Cuentas al
                      CPCCS
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase3_1_2022}>
                      Entrega del Informe de Rendición de Cuentas al CPCCS.
                    </a>
                  </li>

                  <li>
                    <a href={fase3_2_2022}>
                      Entrega del Informe de Rendición de Cuentas a los órganos
                      de control del Estado.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>
        </div>
      </div>

      <div className="layout8 ">
        <h2>Periodo 2021</h2>
        <div>
          <ul className="padding2">
            <li>
              <a href={informeanual_2021}>Informe anual</a>
            </li>
            <li>
              <a href={formulario_2021}>
                Formulario del Consejo de Participación Ciudadana y Control
                Social
              </a>
            </li>
          </ul>
          <Accordion
            title="Fase 0"
            content={
              <>
                {" "}
                <p>
                  <u>
                    <strong>
                      FASE 0: Organización interna institucional del proceso de
                      rendición de cuentas
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase0_1_2021}>
                      Conformación del equipo responsable de la implementación
                      del proceso de rendición de cuentas.
                    </a>
                  </li>

                  <li>
                    <a href={fase0_2_2021}>
                      Diseño de la propuesta y las herramientas necesarias para
                      su desarrollo.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>
          <Accordion
            title="Fase 1"
            content={
              <>
                <p>
                  <u>
                    <strong>FASE 1: Elaboración del informe de RC</strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase1_1_2021}>
                      Consolidación de la información cuantitativa y cualitativa
                      de la gestión anual y evaluación de los resultados
                      alcanzados en el período fiscal concluido.
                    </a>
                  </li>

                  <li>
                    <a href={fase1_2_2021}>
                      Apertura de canales de comunicación virtual y presencial
                      para recabar solicitudes de información en el proceso de
                      rendición de cuentas.
                    </a>
                  </li>
                  <li>
                    <a href={fase1_3_2021}>
                      Recepción y análisis de la información.
                    </a>
                  </li>
                  <li>
                    <a href={fase1_4_2021}>
                      Carga de la información en el formulario de Rendición de
                      Cuentas y redacción del Informe de Rendición de Cuentas.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 2"
            content={
              <>
                <p>
                  <u>
                    <strong>
                      FASE 2: Deliberación sobre el Informe de RC presentado por
                      la autoridad a la ciudadanía.
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase2_1_2021}>
                      Difusión del Informe de Rendición de Cuentas 2022.
                    </a>
                  </li>

                  <li>
                    <a href={fase2_2_2021}>
                      Convocatoria pública y abierta a la presentación pública
                      del Informe de Rendición de Cuentas 2022.
                    </a>
                  </li>
                  <li>
                    <a href={fase2_3_2021}>
                      Deliberación pública presencial y con transmisión en vivo
                      del Informe de Rendición de Cuentas 2022.
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/utpl.loja/videos/306442491411314">
                      Difusión del video de deliberación pública de la Rendición
                      de Cuentas, formulario de rendición de cuentas e Informe
                      de Rendición de Cuentas para receptar aportes ciudadanos.
                      .
                    </a>
                  </li>

                  <li>
                    <a href={fase2_5_2021}>
                      Sistematización de los aportes ciudadanos recibidos y
                      elaboración del Acta de Compromiso. .
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>

          <Accordion
            title="Fase 3"
            content={
              <>
                <p>
                  <u>
                    <strong>
                      FASE 3: Entrega del Informe de Rendición de Cuentas al
                      CPCCS
                    </strong>
                  </u>
                </p>
                <ol>
                  <li>
                    <a href={fase3_1_2021}>
                      Entrega del Informe de Rendición de Cuentas al CPCCS.
                    </a>
                  </li>

                  <li>
                    <a href={fase3_2_2021}>
                      Entrega del Informe de Rendición de Cuentas a los órganos
                      de control del Estado.
                    </a>
                  </li>
                </ol>
              </>
            }
          ></Accordion>
        </div>
      </div>

      <div className="padding"></div>
    </>
  );
}

export default Rendicion;
